module.exports = __webpack_public_path__ + "img/zapier-image.93308d54.png";